export default __webpack_public_path__ + "static/media/redXCircle.c5021a20.svg";